import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'About',
    href: '#about'
  }, {
    name: 'Services',
    href: '#services'
  }, {
    name: 'Team',
    href: '#team'
  }];
  const menuVariants = {
    closed: {
      opacity: 0,
      y: '-100%',
      transition: {
        duration: 0.5,
        ease: [0.22, 1, 0.36, 1]
      }
    },
    open: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5,
        ease: [0.22, 1, 0.36, 1]
      }
    }
  };
  const linkVariants = {
    closed: {
      opacity: 0,
      y: 20
    },
    open: (i: number) => ({
      opacity: 1,
      y: 0,
      transition: {
        delay: 0.3 + i * 0.1,
        duration: 0.5,
        ease: 'easeOut'
      }
    })
  };
  return <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${isScrolled ? 'bg-[#1B4D3E]/95 backdrop-blur-md shadow-lg py-3 border-b border-[#D4AF37]/20' : 'bg-transparent py-6'}`} data-id="element-106">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-107">
        <div className="flex justify-between items-center" data-id="element-108">
          {/* Logo */}
          <div className="flex-shrink-0 flex items-center z-50" data-id="element-109">
            <a href="#" className="block group relative z-50" data-id="element-110">
              <div className="w-20 h-20 flex items-center justify-center transition-transform duration-300 ease-out group-hover:scale-[3] origin-center bg-transparent" data-id="element-111">
                <img src="https://cdn.magicpatterns.com/uploads/1WRKNfF2etQMe5cv3dKkhu/This_is_the_logo.jpg" alt="Flicker Digital Africa" className="w-14 h-auto object-contain" data-id="element-112" />
              </div>
            </a>
          </div>

          {/* Desktop Menu */}
          <div className="hidden md:flex space-x-8 items-center" data-id="element-113">
            {navLinks.map(link => <a key={link.name} href={link.href} className="text-sm font-medium text-white hover:text-[#D4AF37] transition-colors duration-300 font-serif tracking-wide" data-id="element-114">
                {link.name}
              </a>)}
            <a href="#contact" className="px-6 py-2.5 rounded-sm bg-[#D4AF37] text-[#1B4D3E] text-sm font-bold hover:bg-[#F4CF57] transition-all duration-300 shadow-[0_0_15px_rgba(212,175,55,0.3)] hover:shadow-[0_0_25px_rgba(212,175,55,0.5)] uppercase tracking-wider" data-id="element-115">
              Get Started
            </a>
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden z-50" data-id="element-116">
            <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="p-2 text-white hover:text-[#D4AF37] transition-colors" data-id="element-117">
              {isMobileMenuOpen ? <X size={28} data-id="element-118" /> : <Menu size={28} data-id="element-119" />}
            </button>
          </div>
        </div>
      </div>

      {/* Full Screen Mobile Menu */}
      <AnimatePresence data-id="element-120">
        {isMobileMenuOpen && <motion.div initial="closed" animate="open" exit="closed" variants={menuVariants} className="fixed inset-0 bg-[#1B4D3E] z-40 flex flex-col justify-center items-center md:hidden" data-id="element-121">
            <div className="flex flex-col space-y-8 text-center" data-id="element-122">
              {navLinks.map((link, i) => <motion.a key={link.name} custom={i} variants={linkVariants} href={link.href} onClick={() => setIsMobileMenuOpen(false)} className="text-4xl font-serif text-white hover:text-[#D4AF37] transition-colors duration-300" data-id="element-123">
                  {link.name}
                </motion.a>)}
              <motion.div custom={4} variants={linkVariants} className="pt-8" data-id="element-124">
                <a href="#contact" onClick={() => setIsMobileMenuOpen(false)} className="inline-block px-8 py-4 bg-[#D4AF37] text-[#1B4D3E] text-lg font-bold uppercase tracking-widest hover:bg-[#F4CF57] transition-colors" data-id="element-125">
                  Get Started
                </a>
              </motion.div>
            </div>

            {/* Decorative Elements */}
            <div className="absolute bottom-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-[#D4AF37] to-transparent opacity-50" data-id="element-126" />
          </motion.div>}
      </AnimatePresence>
    </nav>;
}